import { render, staticRenderFns } from "./SurveyQuestionEditorImage.vue?vue&type=template&id=504ebf2c&"
import script from "./SurveyQuestionEditorImage.vue?vue&type=script&lang=js&"
export * from "./SurveyQuestionEditorImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports